'use client'

import { Fragment, useEffect, useMemo } from 'react'
import { useMediaQuery } from '@segway/core'
import type { GetFormilyBlockQuery } from '@segway/core/src/graphql/generated/graphql'
import { appSessionStorage } from '@segway/core/src/utils'

import { Arrow, Close, Line } from '@/components/icons'
import { Link } from '@/i18n/navigation'

interface HeaderTopProps {
  homeTopDatas: GetFormilyBlockQuery
  promotionOpen: boolean
  setPromotionOpen: (value: boolean) => void
}

const HeaderTop = ({ homeTopDatas, promotionOpen, setPromotionOpen }: HeaderTopProps) => {
  const responsive = useMediaQuery()

  const pageData = useMemo(() => {
    if (homeTopDatas?.formilyBlock?.block_data) {
      const parseData =
        homeTopDatas?.formilyBlock?.block_data && JSON.parse(homeTopDatas?.formilyBlock?.block_data)
      return parseData
    }
  }, [homeTopDatas])

  const handleClosePromotion = () => {
    appSessionStorage.setItemSync('close_head_promotion', true)
    // reload
    setPromotionOpen(false)
    if (document.documentElement.style.overflow) {
      window.location.reload()
    }
  }

  useEffect(() => {
    const isConsent = appSessionStorage.getItemSync('close_head_promotion')
    if (!isConsent) {
      setPromotionOpen(true)
    }
  }, [setPromotionOpen])

  return responsive && responsive.xl ? (
    <>
      {pageData && (
        <div
          id="header-promotion"
          className="relative z-[2] m-auto flex w-full max-w-[2560px] items-center justify-center bg-black px-[12px] xl:h-[48px] xl:px-[24px]">
          <div className="flex w-full items-center justify-between 2xl:max-w-[1440px]">
            <div className="flex items-center justify-center text-[13px] text-white">
              {pageData && pageData.home_link && pageData.home_link.title ? (
                <>
                  <Link
                    className="font-miSansRegular330 text-[#BBBBBD] underline"
                    target="_blank"
                    href={`${pageData.home_link.link}`}>
                    {pageData.home_link.title}
                  </Link>
                  <span className="mx-[11px] hidden xl:inline">
                    <Line />
                  </span>
                </>
              ) : null}
              {pageData && pageData?.promotion && pageData?.promotion?.is_enable === '1' ? (
                <>
                  <div className="mr-2 flex items-center justify-between">
                    <div className="font-miSansRegular330 text-[12px] text-gray-3 xl:text-[13px]">
                      {pageData?.promotion?.promotion}
                    </div>
                    <div className="xl:hidden">
                      <Close color="#BBBBBD" width={12} height={12} />
                    </div>
                  </div>
                  {!!pageData?.promotion?.link && (
                    <Link
                      href={pageData?.promotion?.link}
                      className="hidden items-center justify-center gap-x-1 text-red-500 xl:flex">
                      {pageData?.promotion?.link_text}{' '}
                      <Arrow width={16} height={16} color="#DA291C" />
                    </Link>
                  )}
                </>
              ) : null}
            </div>

            {pageData ? (
              <div className="hidden items-center justify-center gap-x-[11px] text-white xl:flex">
                {pageData?.links?.map((item: { title: string; link: string }, index: number) => (
                  <Fragment key={index}>
                    {index ? (
                      <span>
                        <Line />
                      </span>
                    ) : null}
                    <Link className="text-[13px] text-[#BBBBBD]" href={item?.link}>
                      {item?.title}
                    </Link>
                  </Fragment>
                ))}
              </div>
            ) : null}
          </div>
        </div>
      )}
    </>
  ) : promotionOpen && pageData && pageData?.promotion && pageData?.promotion?.is_enable === '1' ? (
    <div
      id="header-promotion"
      className={`relative z-[2] flex items-center justify-between gap-3 bg-black py-[6px] pl-[17px] pr-[14px] ${responsive && !responsive.xl ? 'h-[30px]' : ''}`}>
      <Link
        className="overflow-hidden text-ellipsis whitespace-nowrap text-[12px] leading-[16px] text-[#BBBBBD] underline"
        href={pageData?.promotion?.link || ''}
        target="_blank">
        {pageData?.promotion?.promotion}
      </Link>
      <div className="shrink-0" onClick={handleClosePromotion}>
        <Close color="#BBBBBD" width={16} height={16} rotate={45} />
      </div>
    </div>
  ) : null
}

export default HeaderTop
